import { useEffect, useState } from 'react';
import AddBottomButton from '../../../components/Add/AddBottomButton';
import AddModel from '../../../components/Add/AddModel';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs'
import { useNavigate, useParams } from 'react-router-dom'
import AddInputs from '../../../components/Add/AddInputs';
import S3ImageUpload from '../../../components/S3uploads/S3ImageUpload';
import TextArea from '../../../components/inputfields/TextArea';
import useApi from '../../../services/useApi';
import { useDispatch } from 'react-redux';
import { setField, updateServiceFee } from './OnTargetAchievementSlice';
import { useSelector } from 'react-redux';
import { ServiceFeeData } from './types';
import moment from 'moment';
import { convertDate } from '../../../components/commonfunctions/convertDate';
import { showToast } from '../../../components/toastMessage/toastSlice';

export default function AddOnTargetAchievement() {
    const { getAPI, PostAPI } = useApi();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const targetDetails = useSelector((state: any) => state.serviceFeeData);
    const { id, dataId } = useParams();
    const [errors, setErrors] = useState({
        service_fee_received_date: '',
        achievement_amount_received: '',
        receipt_url: ''
    });
    const handleAccounts = async () => {
        let response = await getAPI(`mnos/targets/${id}/${dataId}`);
        console.log(response, 'asdsdaas')

        dispatch(updateServiceFee({
            account_name: response?.data?.data?.account_name,
            account_id: response?.data?.data?.account_id,
            service_fee_received_date: '',
            service_fee_type: 'On Target Achievement',
            from_date: moment(response?.data?.data?.from_date, 'DD-MM-YYYY').format('DD MMM YYYY'),
            to_date: moment(response?.data?.data?.to_date, 'DD-MM-YYYY').format('DD MMM YYYY'),
            target_amount: response?.data?.data?.target_amount,
            target_achieved: response?.data?.data?.target_achieved,
            on_target_service_fee_percentage: response?.data?.data?.on_target_service_fee_percentage,
            achievement_amount_received: 0,
            receipt_url: '',
            note: ''
        }))
    }

    useEffect(() => {
        handleAccounts()
        console.log(targetDetails, 'targetDetails')
    }, [])

    const inputs = [
        {
            "": {
                "Account": {
                    required: true,
                    disabled: true,
                    id: `account_name`,
                    type: "input",
                    tabIndex: 0,
                    bddtestId: `account_name`,
                    dropdownTestId: `account_name_value`,
                },
                "Service Fee Received Date": {
                    required: true,
                    disabled: false,
                    id: "service_fee_received_date",
                    type: "date",
                    tabIndex: 1,
                    bddTestId: 'service_fee_received_date',
                },
                "Service Fee Type": {
                    required: true,
                    disabled: true,
                    id: "service_fee_type",
                    type: "input",
                    tabIndex: 2,
                    bddTestId: 'service_fee_type',
                }
            }
        },
        {
            "": {
                "From Date": {
                    required: true,
                    disabled: true,
                    id: `from_date`,
                    type: "date",
                    tabIndex: 0,
                    bddtestId: `from_date`,
                },
                "To Date": {
                    required: true,
                    disabled: true,
                    id: "to_date",
                    type: "date",
                    tabIndex: 1,
                    bddTestId: 'to_date',
                },
                "Target Set": {
                    required: true,
                    disabled: true,
                    id: "target_amount",
                    type: "currency",
                    tabIndex: 2,
                    bddTestId: 'target_amount',
                    customWidth: true,
                },
                "On Target Achievement Service Fee Percentage": {
                    required: true,
                    disabled: true,
                    id: "on_target_service_fee_percentage",
                    type: "input",
                    tabIndex: 3,
                    bddTestId: 'on_target_service_fee_percentage',
                },
                "Target Achieved": {
                    required: true,
                    disabled: true,
                    id: "target_achieved",
                    type: "currency",
                    tabIndex: 4,
                    bddTestId: 'target_achieved',
                    customWidth: true,
                },
                "On Target Achievement Amount Received": {
                    required: true,
                    disabled: false,
                    id: "achievement_amount_received",
                    type: "currency",
                    tabIndex: 5,
                    bddTestId: 'achievement_amount_received',
                    customWidth: true,
                }
            }
        },
    ]

    const handleSubmit = async () => {
        setLoading(true);

        // Reset all errors
        const newErrors = {
            service_fee_received_date: '',
            achievement_amount_received: '',
            receipt_url: ''
        };

        let hasError = false;

        // Validate service_fee_received_date
        if (!targetDetails.service_fee_received_date) {
            newErrors.service_fee_received_date = 'This field is required';
            hasError = true;
        }

        // Validate achievement_amount_received
        if (!targetDetails.achievement_amount_received) {
            newErrors.achievement_amount_received = 'This field is required';
            hasError = true;
        }

        // Validate receipt_url
        if (!targetDetails.receipt_url) {
            newErrors.receipt_url = 'This field is required';
            hasError = true;
        }

        setErrors(newErrors);

        if (hasError) {
            setLoading(false);
            return;
        }

        try {
            // Prepare the data for submission
            const payload = {
                account_name: targetDetails.account_name,
                account_id: targetDetails.account_id,
                service_fee_received_date: convertDate(targetDetails.service_fee_received_date),
                from_date: convertDate(targetDetails.from_date),
                to_date: convertDate(targetDetails.to_date),
                target_amount: Number(targetDetails.target_amount),
                target_achieved: Number(targetDetails.target_achieved),
                on_target_service_fee_percentage: Number(targetDetails.on_target_service_fee_percentage),
                achievement_amount_received: Number(targetDetails.achievement_amount_received),
                receipt_url: targetDetails.receipt_url,
                note: targetDetails.note
            };

            // // Submit data to API
            const response = await PostAPI(`mnos/targets/${id}/${dataId}`, payload);
            console.log(response, 'response');
            if (!response?.error) {
                dispatch(
                    showToast({
                        type: "success",
                        message: response?.data?.message || "Payment completed successfully",
                    })
                );
                navigate(`/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`);
            } else {
                dispatch(
                    showToast({
                        type: "error",
                        message: response?.data?.response?.data?.message || "Failed to pay bill.",
                    })
                );
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            // Handle submission error
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (id: string, value: string | File) => {
        // For file uploads (receipt_url)
        if (errors[id as keyof typeof errors]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [id]: ''
            }));
        }
        if (id === 'receipt_url' && value instanceof File) {
            // If you're handling file uploads differently, adjust accordingly
            dispatch(setField({ key: 'receipt_url', value: URL.createObjectURL(value) }));
            return;
        }

        // For notes field
        if (id === 'notes') {
            dispatch(setField({ key: 'note', value }));
            return;
        }

        // For all other fields
        dispatch(setField({ key: id as keyof ServiceFeeData, value }));
    };
    return (
        <div>
            <Breadcrumbs
                navPath={["MNO Management", "List of MNO's", "View Details", "List of On Target Achievement", "Add On Target Achievement"]}
                heading="Add On Target Achievement"
                noNavigation
                links={["/mno-management/list-of-mnos", "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`, `/mno-management/list-of-mnos/view-mno/${id}/on-target-achievement`]}
                hasAddPrivilege={true}
            />
            <AddModel>
                <AddInputs
                    inputs={inputs[0]}
                    totalInputCount={3}
                    inputValues={{
                        account_name: targetDetails?.account_name || "",
                        service_fee_received_date: targetDetails?.service_fee_received_date || "",
                        service_fee_type: "On Target Achievement",
                    }}
                    mapping={true}
                    onInputChange={(id, value) => handleInputChange(id, value)}
                    errors={errors}
                />
                <div className='bg-background_blue p-4 rounded-lg'>
                    <AddInputs
                        inputs={inputs[1]}
                        totalInputCount={6}
                        inputValues={{
                            from_date: targetDetails?.from_date || "",
                            to_date: targetDetails?.to_date || "",
                            target_amount: targetDetails?.target_amount || "",
                            on_target_service_fee_percentage: targetDetails?.on_target_service_fee_percentage || "",
                            target_achieved: targetDetails?.target_achieved || "",
                            achievement_amount_received: targetDetails?.achievement_amount_received || "",
                        }}
                        mapping={true}
                        onInputChange={(id, value) => handleInputChange(id, value)}
                        errors={errors}
                    />
                    <S3ImageUpload
                        heading=''
                        label="Upload Document"
                        disabled={false}
                        upload_id={"receipt_url"}
                        UploadPath={"uploads/manual-entries/reciepts"}
                        handleUpload={(file, upload_id) => handleInputChange(file, upload_id)}
                        uploadedFile={targetDetails?.receipt_url || ""}
                        id='reciept_url'
                        required={true}
                        errorMessage={errors.receipt_url}
                        paddingTop={'pt-1'}
                    />
                    <div className=' h-full'>
                        <TextArea
                            label="Notes"
                            required={false}
                            placeholderRequied={false}
                            text={targetDetails?.note || ""}
                            setText={(value: any) => handleInputChange('notes', value)}
                            textError={''}
                            setTextError={() => { }}
                            bgColor={"bg-background_blue"}
                            maxLength={250}
                            id={`notes`}
                        />
                    </div>
                </div>
            </AddModel>
            <AddBottomButton buttonName='Add On Target Achievement' buttonWidth='w-[255px]' onClick={handleSubmit} loading={loading} />
        </div>
    )
}
